<script setup>
import {computed, inject} from "vue";
import {mdiCheckboxMarked} from "@mdi/js";

const props = defineProps({
    value: {
        required: true,
    }
});

const inputValue = inject('selectionButtonValue');
const inputValueUpdate = inject('selectionButtonValueUpdate');
const buttonProps = inject('selectionButtonProps');

const isSelected = computed(() => {
    return inputValue.value === props.value;
});
</script>

<template>
    <v-btn type="button"
           class="flex-grow-1"
           :variant="isSelected ? 'flat' : 'tonal'"
           rounded="sm"
           :ripple="false"
           v-bind="buttonProps"
           @click="inputValueUpdate(value)">
        <slot></slot>
        <v-icon v-if="isSelected" class="ml-3" :icon="mdiCheckboxMarked" />
    </v-btn>
</template>
